import { render, staticRenderFns } from "./historyValue.vue?vue&type=template&id=781fba70&scoped=true&"
import script from "./historyValue.vue?vue&type=script&lang=js&"
export * from "./historyValue.vue?vue&type=script&lang=js&"
import style0 from "./historyValue.vue?vue&type=style&index=0&id=781fba70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781fba70",
  null
  
)

export default component.exports